// Indian states and union territories with their GSTIN state-code prefixes.
// The first two digits of a GSTIN are the registration state's code, which is
// what lets the supplier form cross-check the selected state against the
// entered GSTIN. The backend keeps the same map for server-side validation.
export interface IndianState {
  name: string;
  gstCode: string;
}

export const INDIAN_STATES: IndianState[] = [
  { name: 'Jammu and Kashmir', gstCode: '01' },
  { name: 'Himachal Pradesh', gstCode: '02' },
  { name: 'Punjab', gstCode: '03' },
  { name: 'Chandigarh', gstCode: '04' },
  { name: 'Uttarakhand', gstCode: '05' },
  { name: 'Haryana', gstCode: '06' },
  { name: 'Delhi', gstCode: '07' },
  { name: 'Rajasthan', gstCode: '08' },
  { name: 'Uttar Pradesh', gstCode: '09' },
  { name: 'Bihar', gstCode: '10' },
  { name: 'Sikkim', gstCode: '11' },
  { name: 'Arunachal Pradesh', gstCode: '12' },
  { name: 'Nagaland', gstCode: '13' },
  { name: 'Manipur', gstCode: '14' },
  { name: 'Mizoram', gstCode: '15' },
  { name: 'Tripura', gstCode: '16' },
  { name: 'Meghalaya', gstCode: '17' },
  { name: 'Assam', gstCode: '18' },
  { name: 'West Bengal', gstCode: '19' },
  { name: 'Jharkhand', gstCode: '20' },
  { name: 'Odisha', gstCode: '21' },
  { name: 'Chhattisgarh', gstCode: '22' },
  { name: 'Madhya Pradesh', gstCode: '23' },
  { name: 'Gujarat', gstCode: '24' },
  { name: 'Dadra and Nagar Haveli and Daman and Diu', gstCode: '26' },
  { name: 'Maharashtra', gstCode: '27' },
  { name: 'Karnataka', gstCode: '29' },
  { name: 'Goa', gstCode: '30' },
  { name: 'Lakshadweep', gstCode: '31' },
  { name: 'Kerala', gstCode: '32' },
  { name: 'Tamil Nadu', gstCode: '33' },
  { name: 'Puducherry', gstCode: '34' },
  { name: 'Andaman and Nicobar Islands', gstCode: '35' },
  { name: 'Telangana', gstCode: '36' },
  { name: 'Andhra Pradesh', gstCode: '37' },
  { name: 'Ladakh', gstCode: '38' },
  { name: 'Other Territory', gstCode: '97' }
];
